import {axiosInstance} from "../instance";

const ImageUpload = (reportId, imageData) => {
    return axiosInstance.post(`/api/upload/image/${reportId}`, imageData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

const ReportImageList = (reportId) => {
    return axiosInstance.get(`/api/images/${reportId}`);
};

const ReportImageGet = (reportId, imageName) => {
    return axiosInstance.get(`/image/${reportId}/${imageName}`);
};

export {ImageUpload, ReportImageGet, ReportImageList}
